export default {
	"components.MakeAnOnlinePayment": "進行在線付款",
	"components.ClickOnTheUpperRightCornerOfTheScreen": "點擊屏幕右上角",
	"components.SelectABrowserToOpenThisPage": "，選擇瀏覽器打開本頁"
}